module.exports = __webpack_public_path__ + "img/icon_heart.e33455ff.svg";